"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTM_REQUESTER_ACCOUNTS = exports.TTM_PROVIDER_ACCOUNTS = void 0;
exports.TTM_PROVIDER_ACCOUNTS = ["4509", "2841", "4444", "3517", "5164"];
exports.TTM_REQUESTER_ACCOUNTS = ["4510", "3075", "4355"];
